/**
 * Alice in Bloom — bloom trail
 * Subtle cursor petals on desktop only.
 */
(function () {
  'use strict';

  var INTENSITY = {
    low: { maxParticles: 6, throttleMs: 110, opacity: 0.28, lifeMs: 1200 },
    medium: { maxParticles: 10, throttleMs: 75, opacity: 0.38, lifeMs: 1400 },
    high: { maxParticles: 14, throttleMs: 50, opacity: 0.48, lifeMs: 1600 },
  };

  var layer = null;
  var particles = [];
  var lastSpawn = 0;
  var config = INTENSITY.low;
  var enabled = false;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return (
      window.matchMedia('(max-width: 989px)').matches ||
      window.matchMedia('(pointer: coarse)').matches
    );
  }

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function pruneParticles() {
    particles = particles.filter(function (p) {
      return p.parentNode;
    });
  }

  function spawnPetal(x, y) {
    if (!layer || particles.length >= config.maxParticles) return;

    var petal = document.createElement('span');
    petal.className = 'aib-bloom-trail-petal';
    petal.setAttribute('aria-hidden', 'true');

    var rotate = randomBetween(-30, 30);
    var driftX = randomBetween(-0.6, 0.6);
    var driftY = randomBetween(0.8, 1.6);

    petal.style.left = x + 'px';
    petal.style.top = y + 'px';
    petal.style.setProperty('--aib-petal-opacity', String(config.opacity * randomBetween(0.7, 1)));
    petal.style.setProperty('--aib-petal-rotate', rotate + 'deg');
    petal.style.setProperty('--aib-petal-drift-x', driftX + 'rem');
    petal.style.setProperty('--aib-petal-drift-y', driftY + 'rem');
    petal.style.setProperty('--aib-petal-life', config.lifeMs + 'ms');

    layer.appendChild(petal);
    particles.push(petal);

    window.setTimeout(function () {
      if (petal.parentNode) petal.parentNode.removeChild(petal);
      pruneParticles();
    }, config.lifeMs + 50);
  }

  function onMove(e) {
    if (!enabled) return;

    var now = performance.now();
    if (now - lastSpawn < config.throttleMs) return;
    if (Math.random() > 0.55) return;

    lastSpawn = now;
    spawnPetal(e.clientX - randomBetween(2, 8), e.clientY - randomBetween(2, 8));
  }

  function init() {
    var settings = window.AIB_EASTER_EGGS || {};
    if (!settings.bloomTrail) return;
    if (prefersReducedMotion() || isMobile()) return;

    config = INTENSITY[settings.bloomTrailIntensity] || INTENSITY.low;

    layer = document.createElement('div');
    layer.className = 'aib-bloom-trail-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);

    enabled = true;
    window.addEventListener('mousemove', onMove, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
